import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

import EventsConsolidate from './EventsObjectiveTablePre';
import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';

// Shared components
import PortletToolbar from 'components/PortletToolbar';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';

// Component styles
import styles from './styles';
import { Box, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useTranslation, withTranslation } from 'react-i18next';

class EventsObjective extends Component {

    constructor(props) {
        super(props);
        this.EventsConsolidateClick = this.EventsConsolidateClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            typeGraph: 0,
            period: 'w',
            namePeriod: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            nameGraph: [this.props.match.params.nombre_objetivo+' '],
            namePeriodPorlet: [this.translation('period.text.last-hour'), this.translation('period.text.last-day'), this.translation('period.text.last-week'), this.translation('period.text.custom'), this.translation('period.text.last-3-hours'), this.translation('period.text.last-3-days')],
            typePeriod: 2,
        };
    }

    EventsConsolidateClick() {
        this.setState({
            typeGraph: 0,
            isLastEvent: false,
            responseTimeGraphEl: null,
        });
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = this.translation;
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: `${t('period.text.range')}: ${t('period.text.1')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: `${t('period.text.range')}: ${t('period.text.3')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: `${t('period.text.range')}: ${t('period.text.24')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: `${t('period.text.range')}: ${t('period.text.72')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: `${t('period.text.range')}: ${t('period.text.168')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: this.translation('text.range') + ': ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }


    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()
        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
            })
        }
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
	};

    render() {
        const { classes, className, location, ...rest } = this.props;

        const { typeGraph, period,statePeriod, isStatePeriod, responseTimeGraphEl, periodEl, nameGraph, namePeriodPorlet, typePeriod } = this.state;
        let buttonEventsConsolidate;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showPeriodEl = Boolean(periodEl);

        buttonEventsConsolidate = <EventsConsolidatebutton onClick={this.EventsConsolidateClick} />;

        const rootClassName = classNames(classes.root, className);
        const t = this.translation;
        //if (!this.state.dataError) {
            return (
                <>
                <DialogTitle>
                    <Box style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography variant='h4' className='card__text--dark-color'>{nameGraph[typeGraph]}</Typography>
                    <PortletToolbar>
                        <Button
                            variant="text"
                            onClick={this.handleShowResponseTimeGraph}
                            className='card__text--dark-color'
                        >
                        {t('monitoring.tools-section.events.modal.select.type-graph')} <ArrowDropDownIcon/>
                    </Button>
                    <IconButton key="close" aria-label="close" onClick={this.handleClose}><CloseIcon/></IconButton>
                    <Popover
                        anchorEl={responseTimeGraphEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleCloseResponseTimeGraph}
                        open={showResponseTimeGraphEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <div>
                            {buttonEventsConsolidate}
                        </div>
                    </Popover>
                    </PortletToolbar>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Graph
                            typeGraph={typeGraph}
                            period={period}
                            onFirstInfo={this.handleFirstInfo}
                            statePeriod={statePeriod}
                            isStatePeriod={isStatePeriod}
                        />
                    </Box>
                </DialogContent>
                <DialogActions style={{justifyContent: 'start'}}>
                    <Button variant="text" onClick={this.handleShowPeriod} className='card__text--dark-color'>
                        {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon/>
                    </Button>
                    <Popover
                        anchorEl={periodEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleClosePeriod}
                        open={showPeriodEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={true}/>
                    </Popover>                        
                </DialogActions>
                </>
            )
        }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <EventsConsolidate params={props} />;
    }
}

function EventsConsolidatebutton(props) {
    const { t } = useTranslation()
    return (
        <Button variant="text" onClick={props.onClick}>
            {t('monitoring.tools-section.events.modal.button.consolidated')}
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(EventsObjective);